import { getAuthCode } from "./getAuthCode";

export const uploadImageForIdea = async (SetIsError, SetErrorMessage, formData) => {
  try {
    const authCode = await getAuthCode();
    formData.append("auth_code", authCode);

    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/uploadImageForIdea`, {
      method: "POST",
      body: formData, // ✅ send as multipart/form-data
    });

    if (!response.ok) {
      throw new Error("Upload failed");
      return false
    }

    const result = await response.json();
    console.log("Upload success:", result);
    SetIsError(false);
    SetErrorMessage("");
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'image_uploaded',
    }); 
    return true
  } catch (err) {
    SetIsError(true);
    SetErrorMessage(err.message);
    return false
  }
};